import { DeviceConfiguration } from "models/devices/configuration";
import { IconType } from "react-icons";
import { getDeviceBgColor, getDeviceIcon } from "util/device";

interface GeneralProps {
  config?: DeviceConfiguration;
  title?: string;
  subTitle?: string;
  subTitle1?: string;
  showIcon?: boolean;
  topRight?: React.ReactNode;
  children?: React.ReactNode;
}

const DeviceCard: React.FC<GeneralProps> = ({
  config,
  title,
  subTitle,
  subTitle1,
  showIcon = false,
  topRight,
  children,
}) => {
  const Icon: IconType | null = config?.units
    ? getDeviceIcon(config?.units)
    : null;

  return (
    <div
      className={`!z-5 flex h-full w-full flex-col rounded-[20px] ${getDeviceBgColor(
        config?.units || ""
      )} p-4 pb-2 md:p-6 md:pb-4`}
    >
      <div className="mb-4 flex w-full flex-col gap-2 md:flex-row md:justify-between">
        <div className="flex flex-row gap-2">
          <>
            {showIcon && config?.units && Icon && (
              <Icon className="heading-4xl rounded-xl bg-white text-primary" />
            )}
          </>
          <div
            className={`${
              config ? "text-white" : "text-primary"
            } flex w-full flex-row justify-between gap-2 md:flex-row md:items-start`}
          >
            <div className="flex flex-col">
              <h4 className={`heading-md`}>{title}</h4>
              <p
                className={`mt-0 text-txt-md ${
                  config ? "text-white" : "text-secondary"
                }`}
              >
                {subTitle}
              </p>
              <p
                className={`mt-0 text-txt-md ${
                  config ? "text-white" : "text-secondary"
                }`}
              >
                {subTitle1}
              </p>
            </div>
          </div>
        </div>
        <div className={`flex min-w-32 gap-2  md:flex-row md:justify-end`}>
          {topRight}
        </div>
      </div>
      {children}
    </div>
  );
};

export default DeviceCard;
